import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer id="contatti" className="bg-ink text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 lg:px-8 lg:pt-28">
        <div className="grid grid-cols-1 gap-14 border-b border-white/15 pb-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="font-display text-5xl font-extrabold tracking-tighter lg:text-6xl">
              iogama<span className="text-cobalt">.</span>
            </p>
            <div className="mt-6 inline-flex items-center gap-3 border border-white/20 px-4 py-2" data-testid="footer-naples-badge">
              <span className="h-1.5 w-1.5 rounded-full bg-terracotta" />
              <span className="font-mono text-[10px] uppercase tracking-[0.26em] text-white/70">
                Napoli, Campania — Italia
              </span>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/50">
              Hub calzaturiero all'ingrosso nel cuore del Mediterraneo. Marchi selezionati,
              visione globale.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/40">Contatti B2B</p>
            <ul className="mt-5 space-y-3 text-sm" data-testid="footer-contacts">
              <li>
                <a href="mailto:Iogamasrls@gmail.com" className="text-white/80 transition-colors duration-300 hover:text-white" data-testid="footer-email">
                  Iogamasrls@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:+393393254073" className="text-white/80 transition-colors duration-300 hover:text-white" data-testid="footer-phone-gaetano">
                  Gaetano · +39 339 325 4073
                </a>
              </li>
              <li>
                <a href="tel:+393385714281" className="text-white/80 transition-colors duration-300 hover:text-white" data-testid="footer-phone-mariano">
                  Mariano · +39 338 571 4281
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/40">Leadership</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a href="mailto:gaetano.iodice@gmail.com" className="flex items-center gap-1.5 text-white/80 transition-colors duration-300 hover:text-white" data-testid="footer-gaetano">
                  Gaetano Iodice <ArrowUpRight className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a href="tel:+393385714281" className="flex items-center gap-1.5 text-white/80 transition-colors duration-300 hover:text-white" data-testid="footer-mariano">
                  Mariano Iodice <ArrowUpRight className="h-3 w-3" />
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/40">Navigazione</p>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["Catalogo", "#catalogo"],
                ["Leadership", "#leadership"],
              ].map(([label, target]) => (
                <li key={label}>
                  <button
                    onClick={() => scrollToId(target)}
                    className="text-white/80 transition-colors duration-300 hover:text-white"
                    data-testid={`footer-link-${label.toLowerCase().replace(/ /g, "-")}`}
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-start justify-between gap-4 pt-8 sm:flex-row sm:items-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/35" data-testid="footer-copyright">
            iogama — Ingrosso calzature, Napoli
          </p>
        </div>
      </div>
    </footer>
  );
}
